import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "./appConfigService";
import { AppFolioSignUpCompany } from "../_models/appfolioSignUpCompany";

@Injectable()
export class AppFolioService {
  public apiUrl: string;
  httpOptions = {
    headers: new HttpHeaders({
      Authorization:
        "Basic " +
        btoa(
          "bf10879f-80f2-4389-bb4c-391ba254764c:A83U}f;mQ$%N(ueja+YJ^&j94uy9%(}`M!fX3"
        ),
    }),
  };
  constructor(
    private httpClient: HttpClient,
    private readonly appConfigService: AppConfigService
  ) {
    this.apiUrl = appConfigService.buildiumApiUrl;
  }

  /* Save AppFolio Client */
  saveAppFolioCompany(appfolioCompany: AppFolioSignUpCompany) {
    return this.httpClient.post(
      `${this.apiUrl}/CompanyRegistration/AppFolio`,
      appfolioCompany,
      this.httpOptions
    );
  }

  validateVHostName(vHostName: string) {
    return this.httpClient.get(
      `${this.apiUrl}/CompanyRegistration/AppFolio/Validate?vHostName=${vHostName}`
    );
  }

  getClientIPAddress() {
    return this.httpClient.get("https://api.ipify.org?format=json");
  }
}
